import React, { useEffect } from "react";
import M from "materialize-css";
import "./mamas.css";

function MamasPage() {
  useEffect(() => {
    M.Modal.init(document.querySelectorAll(".modal"), {});
    const collapsibles = document.querySelectorAll(
      ".collapsible.procedimentos"
    );
    M.Collapsible.init(collapsibles, {});
  }, []);

  const procedimentos = [
    {
      id: "modal01",
      titulo: "Mamoplastia de Aumento",
      descricao: "Realce da feminilidade",
      imagem: "/images/procedimentos/mamas_aumento.png",
      modalContent: {
        titulo: "Mamoplastia de Aumento",
        descricao:
          "A mamoplastia de aumento é uma cirurgia plástica que utiliza próteses de silicone para aumentar o volume e melhorar o formato das mamas. Indicada para pacientes que desejam realçar a feminilidade ou equilibrar as proporções corporais, a técnica oferece resultados naturais e personalizados. As próteses podem ser posicionadas de diferentes formas, de acordo com o biotipo e a preferência da paciente. As cicatrizes são discretas, geralmente localizadas em regiões pouco visíveis, como no sulco mamário ou ao redor da aréola.",
        perguntas: [
          {
            pergunta: "Quem pode fazer mamoplastia de aumento?",
            resposta:
              "Pessoas com desejo de aumentar o volume das mamas ou corrigir assimetrias leves.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "Não. Elas são discretas e localizadas em regiões pouco perceptíveis.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial dura de 7 a 14 dias, com retorno gradual às atividades.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas o envelhecimento natural e mudanças corporais podem impactá-los ao longo do tempo.",
          },
          {
            pergunta: "Qual o tipo de prótese mais indicado?",
            resposta:
              "A escolha depende do biotipo, dos objetivos da paciente e da avaliação do cirurgião.",
          },
        ],
      },
    },
    {
      id: "modal02",
      titulo: "Mastopexia",
      descricao: "Rejuvenescimento das mamas",
      imagem: "/images/procedimentos/mastopexia.png",
      modalContent: {
        titulo: "Mastopexia",
        descricao:
          "A mastopexia é uma cirurgia plástica que eleva e reposiciona as mamas, corrigindo a flacidez e melhorando seu formato. Indicada para pacientes que apresentam queda das mamas após gestação, amamentação ou envelhecimento, o procedimento devolve a firmeza e uma aparência jovem. A cirurgia pode ser realizada com ou sem o uso de próteses de silicone, dependendo do volume desejado e da avaliação médica. As cicatrizes variam conforme a técnica utilizada, sendo posicionadas de forma estratégica para ficarem discretas.",
        perguntas: [
          {
            pergunta: "Quem pode fazer mastopexia?",
            resposta:
              "Pacientes com mamas flácidas ou caídas que desejam reposicioná-las.",
          },
          {
            pergunta: "É necessário usar próteses?",
            resposta:
              "Não necessariamente. O uso de próteses depende do desejo da paciente e da necessidade de volume.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "São discretas e posicionadas em locais estratégicos, variando conforme a técnica.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial dura cerca de 14 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "São duradouros, mas podem ser impactados por fatores como envelhecimento e alterações no peso.",
          },
        ],
      },
    },
    {
      id: "modal03",
      titulo: "Mamoplastia Redutora",
      descricao: "Alívio e harmonia",
      imagem: "/images/procedimentos/mamas_redutora.png",
      modalContent: {
        titulo: "Mamoplastia Redutora",
        descricao:
          "A mamoplastia redutora é uma cirurgia plástica que reduz o volume das mamas, aliviando desconfortos físicos como dores nas costas e nos ombros. Indicada para pacientes com mamas volumosas e desproporcionais, o procedimento melhora a qualidade de vida e a harmonia corporal. Durante a cirurgia, o excesso de gordura, tecido glandular e pele é removido, e as cicatrizes são posicionadas de forma estratégica para serem discretas. O resultado é um contorno mamário mais leve, firme e proporcional.",
        perguntas: [
          {
            pergunta: "Quem pode fazer mamoplastia redutora?",
            resposta:
              "Pessoas com mamas grandes que causam desconfortos físicos ou dificuldades no dia a dia.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "As cicatrizes são posicionadas em torno das aréolas e nas regiões inferiores das mamas de forma a, sempre que possível, ficarem cobertas pelo biquíni.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva cerca de 14 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "Existe algum risco nessa cirurgia?",
            resposta:
              "Sim, além dos riscos associados a qualquer cirurgia, como infecção e abertura de pontos, por exemplo, as cicatrizes podem ficar visíveis, pode haver redução da sensibilidade nas mamas e assimetrias entre as mamas.",
          },
          {
            pergunta: "A cirurgia melhora a postura?",
            resposta:
              "Sim, a redução do peso das mamas pode ajudar na postura e aliviar dores nas costas.",
          },
        ],
      },
    },
    {
      id: "modal04",
      titulo: "Correção de Assimetria Mamária",
      descricao: "Equilíbrio e proporção",
      imagem: "/images/procedimentos/mamas_assimetria.png",
      modalContent: {
        titulo: "Correção de Assimetria Mamária",
        descricao:
          "A correção de assimetria mamária é uma cirurgia plástica que ajusta diferenças de tamanho, forma ou posição entre as mamas. Indicada para pacientes que apresentam assimetrias visíveis, o procedimento devolve a harmonia corporal e melhora a autoestima. A técnica é personalizada, com incisões mínimas para garantir resultados naturais. As cicatrizes são discretas e posicionadas estrategicamente para ficarem pouco visíveis.",
        perguntas: [
          {
            pergunta: "Quem pode fazer a correção de assimetrias mamárias?",
            resposta:
              "Pacientes com significativas diferenças de tamanho, forma ou posição entre as mamas.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "São discretas e posicionadas de forma a não comprometer a aparência.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva de 14 a 21 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "É possível corrigir assimetrias muito grandes?",
            resposta:
              "Sim, a técnica é personalizada para cada caso, considerando a necessidade de equilíbrio. Em assimetrias muito discretas normalmente é recomendado cirurgia.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas podem ser influenciados por fatores como gravidez, envelhecimento e alterações no peso.",
          },
        ],
      },
    },
    {
      id: "modal05",
      titulo: "Cirurgia de Ginecomastia",
      descricao: "Recuperação da confiança",
      imagem: "/images/procedimentos/ginecomastia.png",
      modalContent: {
        titulo: "Cirurgia de Ginecomastia",
        descricao:
          "A cirurgia de ginecomastia é um procedimento que reduz o excesso de tecido mamário em homens, proporcionando um tórax mais firme e masculino. Indicada para pacientes com aumento glandular ou gordura localizada na região peitoral, a técnica devolve a confiança e melhora o contorno corporal. O procedimento pode incluir a remoção do tecido glandular, gordura ou ambos, com cicatrizes discretas, geralmente localizadas ao redor da aréola ou em regiões pouco visíveis.",
        perguntas: [
          {
            pergunta: "Quem pode fazer a cirurgia de ginecomastia?",
            resposta:
              "Homens com excesso de tecido mamário ou gordura localizada na região peitoral.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "Não. As cicatrizes são discretas e ficam posicionadas em áreas pouco perceptíveis.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial leva cerca de 10 a 14 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas é importante manter um peso saudável e evitar fatores que possam causar recidiva.",
          },
          {
            pergunta: "O procedimento pode ser feito com anestesia local?",
            resposta:
              "Sim, em casos mais leves, pode ser realizado com anestesia local e sedação, conforme avaliação médica.",
          },
        ],
      },
    },
    {
      id: "modal06",
      titulo: "Explante de Próteses Mamárias",
      descricao: "Segurança e conforto",
      imagem: "/images/procedimentos/mamas_explantes.png",
      modalContent: {
        titulo: "Explante de Próteses Mamárias",
        descricao:
          "O explante de próteses mamárias é uma cirurgia que remove os implantes de silicone, indicada para pacientes que desejam retirar as próteses por razões pessoais ou médicas. O procedimento pode incluir a retirada da cápsula ao redor do implante, garantindo segurança e saúde. A cirurgia é planejada de forma personalizada, considerando as características e objetivos da paciente. As cicatrizes são discretas, posicionadas em locais estratégicos, e os resultados oferecem conforto e harmonia ao contorno corporal.",
        perguntas: [
          {
            pergunta: "Quem pode fazer o explante de próteses mamárias?",
            resposta:
              "Pacientes que desejam retirar os implantes por razões estéticas ou médicas.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "São discretas e localizadas de forma a ficarem pouco perceptíveis.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial dura cerca de 14 dias, com retorno gradual às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "É necessário substituir os implantes?",
            resposta:
              "Não necessariamente. O explante pode ser feito com ou sem reposição de novas próteses.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas o contorno pode mudar ao longo do tempo devido ao envelhecimento natural.",
          },
        ],
      },
    },
    {
      id: "modal07",
      titulo: "Correção de Mamilos Invertidos",
      descricao: "Confiança e bem-estar",
      imagem: "/images/procedimentos/mamas_assimetria_mamilo.png",
      modalContent: {
        titulo: "Correção de Mamilos Invertidos",
        descricao:
          "A correção de mamilos invertidos é um procedimento que trata mamilos que se apresentam retraídos ou não projetados. Indicada para pacientes que desejam melhorar a estética ou resolver desconfortos funcionais, a técnica é simples, segura e com resultados naturais. A cirurgia é realizada com incisões mínimas, preservando a sensibilidade e a funcionalidade. As cicatrizes são discretas e posicionadas de forma estratégica para não comprometer a aparência.",
        perguntas: [
          {
            pergunta: "Quem pode fazer a correção de mamilos invertidos?",
            resposta:
              "Pacientes com mamilos retraídos que desejam melhorar a estética ou funcionalidade.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "Não. As cicatrizes são pequenas e ficam discretamente posicionadas.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial dura de 5 a 7 dias, com retorno rápido às atividades.",
          },
          {
            pergunta: "O procedimento afeta a sensibilidade?",
            resposta:
              "A técnica preserva a sensibilidade na maioria dos casos.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas podem ser influenciados por fatores como alterações hormonais ou gravidez.",
          },
        ],
      },
    },
    {
      id: "modal08",
      titulo: "Redução de Aréolas e Mamilos",
      descricao: "Equilíbrio e estética",
      imagem: "/images/procedimentos/mamas_reducao_areola.png",
      modalContent: {
        titulo: "Redução de Aréolas e Mamilos",
        descricao:
          "A cirurgia de redução de aréolas e mamilos é indicada para pacientes que desejam melhorar a proporção ou simetria dessas estruturas. Seja por razões estéticas ou para corrigir alterações congênitas, o procedimento devolve a harmonia e a confiança. A técnica é personalizada, com incisões mínimas para garantir resultados naturais. As cicatrizes são discretas e posicionadas estrategicamente para ficarem pouco visíveis.",
        perguntas: [
          {
            pergunta: "Quem pode fazer a redução de aréolas e mamilos?",
            resposta:
              "Pacientes insatisfeitos com o tamanho ou proporção da aréola e dos mamilos.",
          },
          {
            pergunta: "As cicatrizes são visíveis?",
            resposta:
              "São discretas e posicionadas de forma a não comprometer a aparência.",
          },
          {
            pergunta: "Quanto tempo dura a recuperação?",
            resposta:
              "A recuperação inicial dura cerca de 7 a 10 dias, com retorno rápido às atividades do cotidiano, sem esforços físicos.",
          },
          {
            pergunta: "A sensibilidade será afetada?",
            resposta:
              "Em geral, a sensibilidade é preservada, dependendo da técnica utilizada.",
          },
          {
            pergunta: "Os resultados são permanentes?",
            resposta:
              "Sim, mas podem ser influenciados por fatores como envelhecimento e alterações hormonais.",
          },
        ],
      },
    },
  ];

  return (
    <div>
      <div>
        <h3 className="titulo-cirurgias-page-mamas">Mamas</h3>
      </div>

      {procedimentos.map((procedimento, index) => (
        <div
          key={index}
          className="row-page-mamas"
          id={`containerProcedimentosText${index % 2 === 0 ? "Right" : "Left"}`}
        >
          <div className="col-page-mamas s12">
            <div
              className={`hoverable container-page-mamas ${index % 2 === 0 ? "even" : "odd"}`}
            >
              <div className="image-container-page-mamas">
                <img src={procedimento.imagem} alt={procedimento.titulo} />
              </div>
              <div
                className={`text-container-page-mamas ${index % 2 === 0 ? "right" : "left"}`}
              >
                <h5 className="card-title-page-mamas">{procedimento.titulo}</h5>
                <p className="card-description-page-mamas">
                  {procedimento.descricao}
                </p>
                <a
                  className="modal-trigger custom-btn"
                  href={`#${procedimento.id}`}
                >
                  Saiba mais
                </a>
              </div>
            </div>
          </div>

          <div id={procedimento.id} className="modal">
            <a href="#!" className="modal-close btn-close-icon">
              <i className="material-icons">close</i>
            </a>
            <div className="modal-content-page-mamas">
              <h4 className="modal-title-page-mamas">
                {procedimento.modalContent.titulo}
              </h4>
              <p className="modal-description-page-mamas">
                {procedimento.modalContent.descricao}
              </p>
              <h5 className="questions-title-page-mamas">
                Perguntas Frequentes
              </h5>
              <ul className="collapsible procedimentos">
                {procedimento.modalContent.perguntas.map((pergunta, idx) => (
                  <li key={idx}>
                    <div className="collapsible-header procedimentos-header-page-mamas">
                      {pergunta.pergunta}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M6 9l6 6 6-6" />
                      </svg>
                    </div>
                    <div className="collapsible-body procedimentos-body-page-mamas">
                      <p className="question-page-mamas">{pergunta.resposta}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MamasPage;
